import { getRouteApi } from '@tanstack/react-router';

const analyticsRouteApi = getRouteApi('/_authed/analytics');

export function useAnalyticsRouteSearch() {
  return analyticsRouteApi.useSearch();
}
